import type { i18n as I18n } from "i18next";
import en from "@/locales/en/duels/falling-blocks-versus.json";
import fr from "@/locales/fr/duels/falling-blocks-versus.json";

export const FALLING_BLOCKS_VERSUS_NS = "duels/falling-blocks-versus";

/** Adds this duel's translations to an initialised i18next instance (idempotent). */
export function registerFallingBlocksVersusTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", FALLING_BLOCKS_VERSUS_NS))
    i18n.addResourceBundle("en", FALLING_BLOCKS_VERSUS_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", FALLING_BLOCKS_VERSUS_NS))
    i18n.addResourceBundle("fr", FALLING_BLOCKS_VERSUS_NS, fr, true, true);
}
